// Single source of truth for storefront route path patterns.
//
// Kept import-free (no `@ztechapps/common.utils`, no React) so it is safe to load
// from the raw-Node SSR server entry via `src/server/routeGuard.ts`. That process
// boots un-bundled (`tsx` in dev, `node ./index.js` in prod — only entry-server is
// Vite-bundled), and `config/routes.ts` pulls in `@ztechapps/common.utils`, whose
// ESM named exports the raw Node loader cannot resolve (it crashes the boot).
// `config/routes.ts` references these same constants, so the app router and the
// route guard can never drift.
export const routePaths = {
  HomePage: '/',
  ProductListPage: '/search/list',
  ProductItemPage: '/search/:_id?',
  PostListPage: '/posts',
  PostItemPage: '/post/:_id?',
  CartPage: '/cart',
  CheckoutMessageSent: '/checkout/message-sent/:_id',
  CheckoutSuccess: '/checkout/success/:_id',
  CheckoutCancel: '/checkout/cancel/:_id',
  UseAndCareListPage: '/use-and-care',
  UseAndCareItemPage: '/use-and-care/:_id?',
  AccountBoardsPage: '/account/boards',
  AccountBoardsDetailsPage: '/account/:tabIs/board-detail/:_id',
  AccountOverview: '/account/overview',
  AccountOrders: '/account/orders',
  AccountOrderItem: '/account/orders/:_id?',
  AccountMessages: '/account/messages',
  AccountMessageDetails: '/account/messages/:_id?',
  AccountSettings: '/account/settings',
  InvoicePage: '/invoice',
  InvoiceCheckoutPage: '/invoice/checkout',
  InvoiceViewPage: '/invoice/view/:token',
  InvoiceViewExpiredPage: '/invoice/expired',
  LoginPage: '/account/login',
  JoinPage: '/account/join',
  RegisterPage: '/account/register',
  UpdateUserRegistration: '/account/update-registration',
  ChangePasswordPage: '/account/change-password/:username?/:code?',
  AuthSuccessPage: '/auth/success/:auth',
  AuthFailedPage: '/auth/failed',
}
